import { PurchaseAccountEnI18n } from '../ui-components/account/i18n/account.i18n';
import { PurchaseMethodsBalanceComponent } from '../ui-components/account/i18n/payment-balance.i18n';
import { PurchasePayoutBankEnI18n } from '../ui-components/account/i18n/payout-bank.i18n';

export const BazaAccountEnI18n = {
    dwacc: {
        paymentAndPayout: PurchaseAccountEnI18n,
        payment: {
            balance: PurchaseMethodsBalanceComponent,
        },
        payout: {
            bank: PurchasePayoutBankEnI18n,
        },
    },
};
